<template>
  <div @click="$emit('click')">
    <div class="timeline-date-banner">
      <div class="timeline-date">{{ date.toUpperCase() }}</div>
      <div class="timeline-date-line" />
    </div>
    <!-- This can be an array of elements grouped by date -->
    <div class="timeline-cell">
      <div class="cell-header">{{ title }}</div>
      <div class="cell-subtext">{{ subtext }}</div>
      <div class="icon-title-container">
        <v-icon small>{{ iconName }}</v-icon>
        <span class="title">{{ iconText }}</span>
      </div>
      <div style="display: flex">
        <span
          v-for="status in statusList"
          :key="status"
          v-bind:class="[
            currentStatus.toLowerCase() === status.toLowerCase()
              ? 'status-title-bold'
              : 'status-title-normal'
          ]"
        >
          {{ status }}
        </span>
      </div>
      <!-- For dicom images: -->
      <!-- <div class="timeline-image-container" /> -->
      <!-- We'll add lab graph as well once its fully designed -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineCell',
  props: {
    date: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtext: {
      type: String,
      default: ''
    },
    iconText: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    currentStatus: {
      type: String,
      default: ''
    },
    statusList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>
.timeline-date-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4f4f4f;
  margin: 12px 0;
}

.timeline-date {
  margin: 0px 0px;
  color: #3c4043;
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  font-style: normal;
  width: 155px;
  letter-spacing: 0.8px;
}

.timeline-date-line {
  background: rgba(33, 33, 33, 0.08);
  height: 1px;
  width: 100%;
}

.timeline-image-container {
  width: 105px;
  height: 97px;
  background: #eeeeee;
}

.timeline-cell {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}

.timeline-cell .cell-header {
  color: #202124;
  line-height: 24px;
}

.timeline-cell .cell-subtext {
  color: #5f6368;
}

.icon-title-container {
  display: flex;
}

.title {
  font-size: 12px;
  color: #3c4043;
  padding-left: 3px;
  font-style: normal;
  font-weight: bold;
  text-transform: capitalize;
}

.status-title-normal {
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  line-height: 18px;
  text-align: left;
  color: #828282;
  margin-right: 20px;
  font-weight: 400;
  opacity: 0.85;
}

.status-title-bold {
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  line-height: 18px;
  text-align: left;
  color: #828282;
  margin-right: 20px;
  font-weight: 900;
}
</style>
